export default function refreshHeaderShopName(name){
        document.querySelector('header .store-locator-link .shop-name').innerHTML = name;
}
